<template>
  <v-list-group
    :value="isOpen"
    no-action
    sub-group
    :prepend-icon="navigationItem.icon"
  >
    <template v-slot:activator>
      <v-list-item-content>
        <v-list-item-title class="stats">
          <span>{{ navigationItem.title }}</span>
          <v-badge
            class="ml-3"
            :value="navigationItem.stat || 0"
            :content="navigationItem.stat || 0"
            color="orange"
          />
          <v-badge
            class="ml-8"
            :value="navigationItem.proStat || 0"
            :content="navigationItem.proStat || 0"
            color="primary"
          />
          <v-badge
            class="ml-8"
            :value="navigationItem.contentReportStat || 0"
            :content="navigationItem.contentReportStat || 0"
            color="red"
          />
        </v-list-item-title>
      </v-list-item-content>
    </template>

    <navigation-item-single
      class="group-items"
      v-for="(item, index) in navigationItem.subItems"
      :navigation-item="item"
      :key="`${item.title}-${index}`"
    />
  </v-list-group>
</template>

<script>
import NavigationItemSingle from "Components/NavigationDrawer/components/NavigationItemSingle";
export default {
  name: "NavigationItemGroup",
  components: { NavigationItemSingle },
  props: {
    navigationItem: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isOpen() {
      if (Array.isArray(this.navigationItem.key)) {
        return this.navigationItem.key.some((key) =>
          this.$route.path.includes(key)
        );
      }
      return this.$route.path.includes(this.navigationItem.key);
    },
  },
};
</script>

<style lang="scss" scoped>
.group-items {
  background-color: rgba(248, 247, 246, 0.9);
}
.stats {
  display: flex;
  padding-bottom: 2px;
}
</style>
